<script>
import FormGroup from '@/pages/components/form/horizontal/form-group.vue'
import formInput from "@wielink-application/shared/js/mixins/formInput";
import Wysiwyg from "@/pages/components/form/input-only/wysiwyg.vue";

export default {
  mixins: [formInput],
  components: {Wysiwyg, FormGroup},
  props: {
    'groupClasses': {
      type: String,
      required: false
    },
    'label': {
      type: String,
      required: false
    }
  }
}
</script>

<template>
  <FormGroup :group-classes="groupClasses" :has-error="hasError" :id="renderedId">
    <template #label>{{ label }}</template>

    <Wysiwyg
        v-bind="$attrs"
        :name="name"
        :form="form"
        :id="renderedId"
        :model-value="modelValue"
        @update:modelValue="changeModelValueTo"
    />
  </FormGroup>
</template>